import { render, staticRenderFns } from "./ProviderSettings_yareto.vue?vue&type=template&id=b3b23dde&scoped=true"
import script from "./ProviderSettings_yareto.vue?vue&type=script&lang=js"
export * from "./ProviderSettings_yareto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3b23dde",
  null
  
)

export default component.exports